import {PROFILE_EDIT_MODAL_CONTENT} from "../components/ProfileEditModalContent";
import {useEffect, useState} from "react";
import {updateGuest} from "../api/updateGuest";
import {createGuest} from "../api/createGuest";

export const useProfileEdit = ({
  formData,
  setFormData,
  guest,
  lineUserId,
}) => {
  const [dialogContent, setDialogContent] = useState<PROFILE_EDIT_MODAL_CONTENT | ''>('');

  const submit = async () => {
    setDialogContent(PROFILE_EDIT_MODAL_CONTENT.LOADING);
    try {
      if (guest?.[0]?.id) {
        const lineToken = localStorage.getItem('lineToken')
        await updateGuest({token: lineToken, guest: {id: guest[0].id, ...formData}});
      } else {
        await createGuest({guest: {lineUserId, ...formData}});
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDialogContent(PROFILE_EDIT_MODAL_CONTENT.SAVED);
    }
  }

  const onConfirmEdit = () => setDialogContent('')

  useEffect(() => {
    if (!guest?.[0]) return;

    const g = guest[0];
    setFormData(prev => ({ ...prev, ...g }))
  }, [guest]);

  return { dialogContent, submit, onConfirmEdit };
}